module.exports = __webpack_public_path__ + "img/block-375.04230d8a.jpg";